import { getDomainEndpoints } from '.';
import URLS from './urls';

const baseEndpoint = getDomainEndpoints();

export function getBaseURL() {
    if (baseEndpoint[window.env]) return baseEndpoint[window.env];
    return baseEndpoint.test;
}

const EndpointSources = {
    remote: () => ({
        oauth: `${getBaseURL()}${URLS.OAUTH}`,
        profile: `${getBaseURL()}${URLS.GET_PROFILE}`,
        subscriptions: `${getBaseURL()}${URLS.GET_SUBSCRIPTIONS}`,
        activeSubscriptions: `${getBaseURL()}${URLS.GET_ACTIVE_SUBSCRIPTIONS}`,
        inactiveSubscriptions: `${getBaseURL()}${URLS.GET_INACTIVE_SUBSCRIPTIONS}`,
        whatsHot: `${getBaseURL()}${URLS.GET_WHATS_HOT}`,
        discoverPublishers: `${getBaseURL()}${URLS.GET_DISCOVER_PUBLISHERS}`,
    }),
    local: () => ({
        oauth: `${baseEndpoint.local}${URLS.OAUTH}`,
        profile: `${baseEndpoint.local}${URLS.GET_PROFILE}`,
        subscriptions: `${baseEndpoint.local}${URLS.GET_SUBSCRIPTIONS}`,
        activeSubscriptions: `${baseEndpoint.local}${URLS.GET_ACTIVE_SUBSCRIPTIONS}`,
        inactiveSubscriptions: `${baseEndpoint.local}${URLS.GET_INACTIVE_SUBSCRIPTIONS}`,
        whatsHot: `${baseEndpoint.local}${URLS.GET_WHATS_HOT}`,
        discoverPublishers: `${baseEndpoint.local}${URLS.GET_DISCOVER_PUBLISHERS}`,
    }),
};

export function endpoints() {
    if (window.env !== undefined && window.env !== 'local') {
        return EndpointSources.remote();
    }
    return EndpointSources.local();
}
